import {RCCLoaderBackdropProvider} from "react-common-components";

export default RCCLoaderBackdropProvider;
